import { render } from "./ConfirmEmail.vue?vue&type=template&id=c9a4ff48&scoped=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"

import "./ConfirmEmail.vue?vue&type=style&index=0&id=c9a4ff48&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9a4ff48"]])

export default __exports__